import { useState } from "react";
import { accountService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState, useDebounce } from "@miplatform/hooks";

export const usePlanDetailsViewModel = () => {
  const [accountDetail, setAccountDetail] = useState({});
  const [search, setSearch] = useState("");

  const stateManager = useComponentState();
  const debouncedSearch = useDebounce(search, 300);

  const getAccountDetail = (id) => {
    stateManager.run(async () => {
      const response = await accountService.accounts.getAccountById({ id });
      if (response.status === HTTP_STATUSES.OK) {
        setAccountDetail(response.data);
      }
    });
  };

  return {
    isLoading: stateManager.isBusy(),
    stateManager,
    accountDetail,
    getAccountDetail,
    search,
    setSearch,
    debouncedSearch,
  };
};
